import { Outlet, Navigate } from "react-router-dom";

const ResProtectedRoutes = () => {
  let auth = localStorage.getItem("jwt_res");
  // console.log(auth);
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default ResProtectedRoutes;
